/* eslint-disable max-len */
import Logo from '../../../../assets/manProDis.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  governanceLeadershipAndOversightTabQuestions,
  policyAndManagementProcessesTabQuestions
} from './managementAndProcessDisclosuresTabs';

export const managementAndprocessDisclosure = {
  header: {
    imageUrl: Logo,
    title: 'SECTION B: MANAGEMENT AND PROCESS DISCLOSURES',
    description: `Addresses social factors, including workforce diversity, labor practices, 
      human rights, community engagement, and social impact initiatives.`,
    noOfModules: 34,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.BRSR.mapDisclosure,
  tabs: [
    {
      id: 'policyAndManagementProcesses',
      title: 'Policy and management processes',
      questions: policyAndManagementProcessesTabQuestions,
      accordion: false
    },
    {
      id: 'governanceLeadershipAndOversight',
      title: 'Governance, leadership and oversight',
      questions: governanceLeadershipAndOversightTabQuestions,
      accordion: false
    }
  ]
};
